// Isolates import.meta access: import.meta is not valid syntax in Jest's CommonJS
// runtime, so jest.config.ts substitutes this module via moduleNameMapper
export const viteMode = import.meta.env.MODE;
